// เมนูกระบวนงานของ Admin — ข้อมูลของ AdminProcessNav.vue (แก้/เพิ่ม/ย้ายเมนูที่ไฟล์นี้ไฟล์เดียว)
// ไฟล์ *_bar.vue / *menu.vue เดิมเป็นตัวห่อที่เรียก <AdminProcessNav v-bind="ADMIN_MENUS.xxx" /> (หน้าเดิมไม่ต้องแก้)
//
// stage: { key, no?, icon?, title, desc, aside?, items: [{ text, icon, to }] }
//   no = ขั้นตอนตามลำดับงาน (มีลูกศรเชื่อม) · ไม่มี no = กลุ่มข้อมูล (แสดง icon) · aside = คอลัมน์เครื่องมือท้ายสุด

export const ADMIN_MENUS = {
  // ---------------------------------------------------------------- ครูผู้ช่วย
  assistantTeacher: {
    title: "กระบวนการครูผู้ช่วย",
    icon: "mdi-human-male-board",
    stages: [
      {
        key: "report", no: 1, title: "เรียกรายงานตัว", desc: "กำหนดรอบ ตำแหน่งว่าง รับรายงานตัว",
        items: [
          { text: "ปฏิทิน/กำหนดรอบ", icon: "mdi-calendar-clock", to: "/admin/periodassteach" },
          { text: "กำหนดการรายงานตัว", icon: "mdi-calendar-check", to: "/admin/timelines/report_assistantteacher" },
          { text: "เลขที่ตำแหน่งว่าง", icon: "mdi-office-building-marker", to: "/admin/assistant_teacher_report/manage_college_manpower" },
          { text: "จับคู่ตำแหน่ง/รายงาน", icon: "mdi-swap-horizontal", to: "/admin/assistant_teacher_report/teacher_college_manpower_report" },
          { text: "รายชื่อผู้ถูกเรียกรายงานตัว", icon: "mdi-account-details", to: "/admin/manage_assistant_teacher_data" },
          { text: "รายงานตัว ณ สถานศึกษา", icon: "mdi-domain", to: "/admin/assistant_teacher_report/manage_assistant_CollegeReport" },
          { text: "รายงานตัว (โอนย้าย)", icon: "mdi-domain-switch", to: "/admin/assistant_teacher_report/manage_assistant_CollegeReportTran" }
        ]
      },
      {
        key: "committee", no: 2, title: "คณะกรรมการประเมิน", desc: "ผู้ทรงคุณวุฒิ และกรรมการรายคน",
        items: [
          { text: "ทะเบียนผู้ทรงคุณวุฒิ", icon: "mdi-account-star", to: "/admin/assistant_teacher_report/assistantcommitteequalified" },
          { text: "เสนอคณะกรรมการรายคน", icon: "mdi-account-group", to: "/admin/assistant_teacher_report/manage_assistant_teacher_committee" }
        ]
      },
      {
        key: "assess", no: 3, title: "ประเมิน 4 ครั้ง", desc: "ตรวจผลทุก 6 เดือน และใบอนุญาต",
        items: [
          { text: "ตรวจผลการประเมิน", icon: "mdi-clipboard-check-outline", to: "/admin/assistant_teacher" },
          { text: "รายละเอียดรายคน", icon: "mdi-account-search", to: "/admin/assistant_teacher_detail" },
          { text: "ใบอนุญาตประกอบวิชาชีพ", icon: "mdi-certificate-outline", to: "/admin/servey_assistant_specialized_licenses" }
        ]
      },
      {
        key: "approve", no: 4, title: "อนุมัติ ครู คศ.1", desc: "สรุปผล ตรวจเงื่อนไข และอนุมัติ",
        items: [{ text: "สรุปผล + อนุมัติ คศ.1", icon: "mdi-file-certificate-outline", to: "/admin/assistant_teacher_reports" }]
      },
      {
        key: "tools", aside: true, icon: "mdi-radar", title: "ติดตาม / ข้อมูล", desc: "ค้างที่ขั้นไหน ใครต้องทำ",
        items: [
          { text: "ติดตามเส้นทางครูผู้ช่วย", icon: "mdi-transit-connection-variant", to: "/admin/assistant_teacher_monitor" },
          { text: "ข้อมูลย้อนหลัง", icon: "mdi-archive-outline", to: "/admin/assistant_teacher_report/manage_assistant_teacher_backup" }
        ]
      }
    ]
  },

  // ---------------------------------------------------------------- ย้ายข้าราชการครู
  teacherTransfer: {
    title: "การย้ายข้าราชการครู",
    icon: "mdi-swap-horizontal-bold",
    stages: [
      {
        key: "prepare", no: 1, title: "เตรียมข้อมูล", desc: "กำหนดการ เงื่อนไขสาขา อัตรากำลัง",
        items: [
          { text: "กำหนดการ", icon: "mdi-calendar-clock", to: "/admin/timelines/transfer_teachers" },
          { text: "รายละเอียดเงื่อนไขสาขา", icon: "mdi-format-list-checks", to: "/admin/conditions_branch" },
          { text: "รายการเงื่อนไขสาขา", icon: "mdi-playlist-check", to: "/admin/conditions_transfer" },
          { text: "อัตรากำลังรับย้าย", icon: "mdi-seat", to: "/admin/man_power" },
          { text: "อัตรากำลังขาด/เกิน", icon: "mdi-chart-bar", to: "/admin/man_powersummary" }
        ]
      },
      {
        key: "applicants", no: 2, title: "ผู้ยื่นคำร้อง", desc: "ตรวจคำร้องและคัดกรอง",
        items: [
          { text: "รายละเอียดผู้ยื่นขอย้าย", icon: "mdi-account-details", to: "/admin/transference_location_detail" },
          { text: "รายการผู้ยื่นขอย้าย", icon: "mdi-account-search", to: "/admin/transference_location" },
          { text: "ประมวลผล 1 (คัดกรอง)", icon: "mdi-filter-outline", to: "/admin/transference_personnel" }
        ]
      },
      {
        key: "process", no: 3, title: "ประมวลผล", desc: "จับคู่อัตโนมัติ สับเปลี่ยน คงค้าง",
        items: [
          { text: "ประมวลผล 2 (ระบบ)", icon: "mdi-robot", to: "/admin/process_transfer" },
          { text: "ประมวลผล 3 (สับเปลี่ยนปกติ)", icon: "mdi-swap-horizontal", to: "/admin/process_transfer_switch_normal" },
          { text: "ประมวลผล 4 (สับเปลี่ยนกรณีพิเศษ)", icon: "mdi-swap-horizontal-bold", to: "/admin/process_transfer_switch" },
          { text: "ประมวลผล 5 (คงค้าง)", icon: "mdi-timer-sand", to: "/admin/pending_transfer" }
        ]
      },
      {
        key: "result", no: 4, title: "สรุปผลและรายงานตัว", desc: "คำสั่งแต่งตั้ง ติดตามรายงานตัว",
        items: [
          { text: "สรุปผลการย้าย", icon: "mdi-check-decagram", to: "/admin/conditons_transfer_success" },
          { text: "รายงานคำสั่งแต่งตั้ง", icon: "mdi-file-document-outline", to: "/admin/Order_appoint" },
          { text: "สถานะการรายงานตัว", icon: "mdi-account-check-outline", to: "/admin/conditons_transfer_success_reportmv" }
        ]
      }
    ]
  },

  // ---------------------------------------------------------------- ย้ายผู้บริหาร
  managerTransfer: {
    title: "การย้ายผู้บริหารสถานศึกษา",
    icon: "mdi-account-tie",
    stages: [
      {
        key: "applicants", no: 1, title: "ผู้เสนอย้าย", desc: "กำหนดการ และรายชื่อผู้ยื่น",
        items: [
          { text: "กำหนดการ", icon: "mdi-calendar-clock", to: "/admin/timelines/transfer_directors" },
          { text: "ผู้เสนอย้ายสายบริหาร", icon: "mdi-account-details", to: "/admin/transference_manage_main" }
        ]
      },
      {
        key: "process", no: 2, title: "ประมวลผล", desc: "ตามผู้ยื่น / ตามวิทยาลัยปลายทาง / อัตโนมัติ",
        items: [
          { text: "ตามผู้ยื่นย้าย (แบบที่ 1)", icon: "mdi-account-arrow-right", to: "/admin/transference_manage_location_detail" },
          { text: "ตามวิทยาลัยปลายทาง (แบบที่ 2)", icon: "mdi-office-building-marker", to: "/admin/transference_manage_location_college" },
          { text: "ประมวลผลย้ายอัตโนมัติ", icon: "mdi-robot", to: "/admin/transference_manage_auto_match" }
        ]
      },
      {
        key: "review", no: 3, title: "พิจารณาและสรุป", desc: "ผลการกลั่นกรอง บทสรุป",
        items: [
          { text: "ผลการพิจารณา กลั่นกรอง", icon: "mdi-gavel", to: "/admin/transference_manage" },
          { text: "บทสรุป", icon: "mdi-file-chart-outline", to: "/admin/transference_manage_report" }
        ]
      },
      {
        key: "report", no: 4, title: "รายงานตัว", desc: "ติดตามการรายงานตัว",
        items: [{ text: "ติดตามการรายงานตัว", icon: "mdi-file-document-check-outline", to: "/admin/conditons_transfer_success_reportmv_director" }]
      }
    ]
  },

  // ---------------------------------------------------------------- ย้ายพนักงานราชการ
  govemTransfer: {
    title: "การย้ายพนักงานราชการ",
    icon: "mdi-account-switch",
    stages: [
      {
        key: "prepare", no: 1, title: "เตรียมข้อมูล", desc: "กำหนดการ อัตรา ตำแหน่งว่าง",
        items: [
          { text: "กำหนดการ", icon: "mdi-calendar-clock", to: "/admin/timelines/transfer_govem" },
          { text: "ข้อมูลอัตรา", icon: "mdi-table-account", to: "/admin/man_power_govem" },
          { text: "รายงานตำแหน่งว่าง", icon: "mdi-file-chart-outline", to: "/admin/government_employee_report" },
          { text: "รายละเอียดตำแหน่งว่าง", icon: "mdi-seat", to: "/admin/college_manpower_govem" }
        ]
      },
      {
        key: "applicants", no: 2, title: "ผู้ยื่นย้าย", desc: "ข้อมูลประกอบการพิจารณา",
        items: [
          { text: "ผู้ยื่นย้าย (ประกอบพิจารณา)", icon: "mdi-account-details", to: "/admin/gov_em/transference_location_detail" },
          { text: "รายการผู้ยื่นย้าย", icon: "mdi-account-search", to: "/admin/gov_em/transference_location" }
        ]
      },
      {
        key: "process", no: 3, title: "ประมวลผล", desc: "คัดกรอง ระบบ สับเปลี่ยน",
        items: [
          { text: "ประมวลผล 1", icon: "mdi-filter-outline", to: "/admin/gov_em/transference_personnel" },
          { text: "ประมวลผล 2 (ระบบ)", icon: "mdi-robot", to: "/admin/gov_em/process_transfer" },
          { text: "ประมวลผล 3 (สับเปลี่ยนปกติ)", icon: "mdi-swap-horizontal", to: "/admin/gov_em/process_transfer_switch_normal" },
          { text: "ประมวลผล 4 (สับเปลี่ยนระบบ)", icon: "mdi-swap-horizontal-bold", to: "/admin/gov_em/process_transfer_switch" }
        ]
      },
      {
        key: "result", no: 4, title: "สรุปผลและรายงานตัว", desc: "คำสั่ง ติดตามรายงานตัว",
        items: [
          { text: "สรุปผล", icon: "mdi-check-decagram", to: "/admin/gov_em/conditons_transfer_success" },
          { text: "รายงานคำสั่ง", icon: "mdi-file-document-outline", to: "/admin/gov_em/Order_appoint" },
          { text: "รายงานตัว", icon: "mdi-account-check-outline", to: "/admin/gov_em/conditons_transfer_success_reportmv" }
        ]
      }
    ]
  },

  // ---------------------------------------------------------------- ย้าย 38 ค.(2)
  transfer38: {
    title: "การย้ายบุคลากร 38 ค.(2)",
    icon: "mdi-account-switch-outline",
    stages: [
      {
        key: "prepare", no: 1, title: "เตรียมข้อมูล", desc: "กำหนดการ ตำแหน่งว่าง",
        items: [
          { text: "กำหนดการ", icon: "mdi-calendar-clock", to: "/admin/timelines/transfer_38" },
          { text: "ตำแหน่งว่างสถานศึกษา", icon: "mdi-seat", to: "/admin/man_power_38" }
        ]
      },
      {
        key: "applicants", no: 2, title: "ผู้ยื่นย้าย", desc: "ข้อมูลและประมวลผล",
        items: [{ text: "ข้อมูลผู้ยื่นย้าย", icon: "mdi-calculator", to: "/admin/transference_personnel_38" }]
      },
      {
        key: "result", no: 3, title: "สรุปผลและรายงานตัว", desc: "คำสั่ง ติดตามรายงานตัว",
        items: [
          { text: "สรุปผล", icon: "mdi-check-decagram", to: "/admin/conditons_transfer_success" },
          { text: "รายงานคำสั่ง", icon: "mdi-file-document-outline", to: "/admin/Order_appoint" },
          { text: "รายงานตัว", icon: "mdi-account-check-outline", to: "/admin/conditons_transfer_success_reportmv" }
        ]
      }
    ]
  },

  // ---------------------------------------------------------------- คัดเลือกรองผู้อำนวยการ
  sedirector: {
    title: "การคัดเลือกรองผู้อำนวยการ",
    icon: "mdi-account-star",
    stages: [
      {
        key: "apply", no: 1, title: "รับสมัคร", desc: "กำหนดการ และข้อมูลผู้สมัคร",
        items: [
          { text: "กำหนดการ รอง ผอ.", icon: "mdi-calendar-clock", to: "/admin/timelines/examination_deputyDirector" },
          { text: "ข้อมูลผู้สมัคร", icon: "mdi-account-details", to: "/admin/sedirector_app" }
        ]
      },
      {
        key: "assess", no: 2, title: "ประเมิน 3 ภาค", desc: "วิทยาลัย สอจ. และ กจ2.",
        items: [
          { text: "ภาค ก. (วิทยาลัย)", icon: "mdi-alpha-a-circle-outline", to: "/admin/sedirector_assessment/sedirector_app_a" },
          { text: "ภาค ข. (สอจ.)", icon: "mdi-alpha-b-circle-outline", to: "/admin/sedirector_assessment/sedirector_app_b" },
          { text: "ภาค ค. (กจ2.)", icon: "mdi-alpha-c-circle-outline", to: "/admin/sedirector_assessment/sedirector_app_c" }
        ]
      },
      {
        key: "notice", no: 3, title: "ประกาศผล", desc: "รายชื่อผู้ผ่านการคัดเลือก",
        items: [{ text: "ประกาศผล", icon: "mdi-bullhorn-outline", to: "/admin/sedirector_assessment/sedirector_app_notice" }]
      },
      {
        key: "placement", no: 4, title: "เลือกสถานศึกษาและรายงานตัว", desc: "ตำแหน่งว่าง เลือก รายงานตัว",
        items: [
          { text: "ตำแหน่งว่างสถานศึกษา", icon: "mdi-seat", to: "/admin/sedirector_assessment/director_college_manpower" },
          { text: "รายงานตัวเลือกสถานศึกษา", icon: "mdi-map-marker-check", to: "/admin/sedirector_assessment/sedirector_app_choose" },
          { text: "รายงานตัว ณ สถานศึกษา", icon: "mdi-domain", to: "/admin/sedirector_assessment/sedirector_app_report_college" }
        ]
      }
    ]
  },

  // ---------------------------------------------------------------- คัดเลือกศึกษานิเทศก์
  supervisor: {
    title: "การคัดเลือกศึกษานิเทศก์",
    icon: "mdi-account-search",
    stages: [
      {
        key: "apply", no: 1, title: "รับสมัคร", desc: "กำหนดการ และข้อมูลผู้สมัคร",
        items: [
          { text: "กำหนดการ ศน.", icon: "mdi-calendar-clock", to: "/admin/timelines/examination_Supervisor" },
          { text: "ข้อมูลผู้สมัคร", icon: "mdi-account-details", to: "/admin/supervisor_app" }
        ]
      },
      {
        key: "placement", no: 2, title: "เลือกสถานศึกษาและรายงานตัว", desc: "ตำแหน่งว่าง เลือก รายงานตัว",
        items: [
          { text: "ตำแหน่งว่างสถานศึกษา", icon: "mdi-seat", to: "/admin/sedirector_assessment/director_college_manpower" },
          { text: "รายงานตัวเลือกสถานศึกษา", icon: "mdi-map-marker-check", to: "/admin/sedirector_assessment/sedirector_app_choose" },
          { text: "รายงานตัว ณ สถานศึกษา", icon: "mdi-domain", to: "/admin/sedirector_assessment/sedirector_app_report_college" }
        ]
      }
    ]
  },

  // ---------------------------------------------------------------- อัตรากำลังสถานศึกษา
  manpower: {
    title: "อัตรากำลังสถานศึกษา",
    icon: "mdi-human-queue",
    stages: [
      {
        key: "config", no: 1, title: "ตั้งค่าระบบ", desc: "กำหนดการและเกณฑ์การคำนวณ",
        items: [{ text: "ตั้งค่าระบบ", icon: "mdi-cog-outline", to: "/admin/sys_config_collegemanpower" }]
      },
      {
        key: "data", no: 2, title: "ข้อมูลประกอบการคำนวณ", desc: "บุคลากร ลูกจ้าง นักเรียน",
        items: [
          { text: "อัตรากำลังสถานศึกษา", icon: "mdi-account-group", to: "/admin/personnel_etc" },
          { text: "ข้อมูลลูกจ้างชั่วคราว", icon: "mdi-account-clock", to: "/admin/personnel_etc_tem" },
          { text: "จำนวนนักเรียน", icon: "mdi-school", to: "/admin/power_rate/rate_work_college" }
        ]
      },
      {
        key: "report", no: 3, title: "รายงาน", desc: "อัตรากำลังประจำปี",
        items: [{ text: "รายงานอัตรากำลังประจำปี", icon: "mdi-file-chart-outline", to: "/admin/rate_work_g" }]
      }
    ]
  },

  // ---------------------------------------------------------------- จ.18 เลขที่ตำแหน่ง
  jor18: {
    title: "เลขที่ตำแหน่ง (จ.18)",
    icon: "mdi-numeric",
    stages: [
      {
        key: "period", no: 1, title: "กำหนดการ", desc: "ช่วงรายงานของสถานศึกษา",
        items: [{ text: "กำหนดการ", icon: "mdi-calendar-clock", to: "/admin/sys_config_collegemanpower_report" }]
      },
      {
        key: "manage", no: 2, title: "จัดการเลขที่ตำแหน่ง", desc: "ข้อมูล จ.18",
        items: [{ text: "จัดการเลขที่ตำแหน่ง", icon: "mdi-format-list-numbered", to: "/admin/jor18" }]
      },
      {
        key: "report", no: 3, title: "การรายงาน", desc: "ผลการรายงานของสถานศึกษา",
        items: [
          { text: "การรายงาน", icon: "mdi-file-chart-outline", to: "/admin/jor18_report" },
          { text: "การรายงาน (เลขที่ตำแหน่ง)", icon: "mdi-file-table-outline", to: "/admin/college_manpower" }
        ]
      }
    ]
  },

  // ---------------------------------------------------------------- อัตรากำลังพนักงานราชการ
  govemManpower: {
    title: "อัตรากำลังพนักงานราชการ",
    icon: "mdi-account-star-outline",
    stages: [
      {
        key: "period", icon: "mdi-calendar-clock", title: "กำหนดการ", desc: "ช่วงรายงานของสถานศึกษา",
        items: [{ text: "กำหนดการ", icon: "mdi-calendar-clock", to: "/admin/gov_em/period_mgovem" }]
      },
      {
        key: "central", icon: "mdi-office-building", title: "ส่วนกลาง", desc: "อัตรากำลังและการประเมิน",
        items: [
          { text: "อัตรากำลัง ส่วนกลาง", icon: "mdi-table-account", to: "/admin/gov_em_vec/government_employee" },
          { text: "ประเมิน ส่วนกลาง", icon: "mdi-star-check-outline", to: "/admin/gov_em_vec/assessment_govem" }
        ]
      },
      {
        key: "college", icon: "mdi-domain", title: "สถานศึกษา", desc: "อัตรากำลังและกรอบอัตรา",
        items: [
          { text: "อัตรากำลัง สถานศึกษา", icon: "mdi-account-group", to: "/admin/gov_em/Governmentemployeereportadmin" },
          { text: "กรอบอัตรากำลัง", icon: "mdi-table-large", to: "/admin/gov_em/government_employee" },
          { text: "รายงานกรอบอัตรากำลัง", icon: "mdi-file-chart-outline", to: "/admin/gov_em/government_employee_report" }
        ]
      },
      {
        key: "finance", icon: "mdi-cash-multiple", title: "การเบิกจ่าย", desc: "รายงาน สนผ.",
        items: [{ text: "รายงานการเบิกจ่าย สนผ.", icon: "mdi-cash-multiple", to: "/admin/government_employee_report_snp" }]
      }
    ]
  },

  // ---------------------------------------------------------------- ข้อมูลบุคลากร
  personnel: {
    title: "ข้อมูลบุคลากร",
    icon: "mdi-account-details",
    stages: [
      {
        key: "unit", icon: "mdi-domain", title: "ตามประเภทหน่วยงาน", desc: "ข้าราชการครูและบุคลากรทางการศึกษา",
        items: [
          { text: "วิทยาลัย (ข้อมูลบุคคล)", icon: "mdi-school", to: "/admin/personnel_tem" },
          { text: "สถาบัน", icon: "mdi-office-building", to: "/admin/personnel_center/?type=C" },
          { text: "ศึกษานิเทศก์", icon: "mdi-account-tie", to: "/admin/personnel_center/?type=S" },
          { text: "38 ค.(2)", icon: "mdi-account-cog", to: "/admin/personnel_center/?type=38" }
        ]
      },
      {
        key: "extra", icon: "mdi-card-account-details-outline", title: "ข้อมูลประกอบ", desc: "ใบอนุญาต จ.18 ครูผู้ช่วย",
        items: [
          { text: "ข้อมูลใบอนุญาต", icon: "mdi-certificate-outline", to: "/admin/personnel_temporaryLicence" },
          { text: "ข้อมูล จ.18", icon: "mdi-format-list-numbered", to: "/admin/jor18" },
          { text: "ครูผู้ช่วย", icon: "mdi-human-male-board", to: "/admin/personnel_temporary_assisstant" }
        ]
      },
      {
        key: "history", icon: "mdi-archive-outline", title: "ผู้พ้นจากราชการ", desc: "ข้อมูลย้อนหลัง",
        items: [{ text: "ผู้พ้นจากราชการ สอศ.", icon: "mdi-account-off-outline", to: "/admin/personnel_temporary_del" }]
      }
    ]
  }
};
